/* eslint-disable import/no-default-export */
import LazyImage from './LazyImage/LazyImage.jsx';

export default LazyImage;
